import { useEffect, useMemo, useState } from 'react';
import type React from 'react';

import { useLocation } from 'react-router';

import { useCurrentRouteConfig } from 'src/app/routes';

const SsrWarningBannerInner: React.FC = () => {
	const location = useLocation();
	const [hasLocationChanged, setHasLocationChanged] = useState<boolean | undefined>(undefined);

	// we should not display the banner after navigating to another route
	// eslint-disable-next-line react-hooks/set-state-in-effect
	useEffect(() => setHasLocationChanged((prevValue) => prevValue !== undefined), [location]);

	const routeConfig = useCurrentRouteConfig();
	// checking if the current route has SSR enabled
	const ssrRoute = useMemo(() => routeConfig?.config.ssr && routeConfig.config.ssr.enabled, [routeConfig]);

	if (hasLocationChanged || !ssrRoute) return null;

	return (
		<div className="bg-fill-brand-strong pointer-events-none fixed top-0 left-0 z-1000000 box-border w-screen text-center text-base leading-6 text-white opacity-75">
			⚠️ This SSR page is currently accessed in CSR mode ⚠️
		</div>
	);
};

export const SsrWarningBanner: React.FC<{ ssr: boolean }> = ({ ssr }) => {
	if (ssr || process.env.NODE_ENV !== 'development') return null;

	// using an inner component to avoid doing route filtering in non-dev env
	return <SsrWarningBannerInner />;
};
